<div id="toggler" class="row align-items-center py-2" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-4">
        <span>{{ material.materialNr.value }}</span> <br />
        <span>{{ material.descTxt }}</span> <br />
    </div>
    @if (material.isMaterialInSmartlocker()) {
        <div class="col-4 d-flex align-items-center">
            <div class="flex-column pe-2">
                <div>{{ material.storageLoc.value }}</div>
                <div>{{ material.storageLocDesc }}</div>
            </div>
            <div class="badge rounded-pill smartlocker-pill-icon bg-lightgreen ps-3">
                <fa-icon [icon]="faBoxes" size="1x" aria-hidden="true"></fa-icon>
            </div>
        </div>
    } @else {
        <div class="col-4">
            <span>{{ material.storageLoc.value }}</span
            ><br />
            <span>{{ material.storageLocDesc }}</span>
        </div>
    }
    <div class="col">
        <span>{{ material.available }}</span>
        <span>&nbsp;</span>
        <span>{{ material.extUnit }}</span>
    </div>
</div>
@if (!isCollapsed) {
    <div>
        <div class="row justify-content-center">
            <div class="col-6">
                <ul class="list-unstyled d-flex flex-column align-items-center">
                    <li>
                        @if (material.longText.length > 0) {
                            @for (line of material.longText; track line) {
                                <span>
                                    @for (part of line.split(';'); track part) {
                                        <div class="mb-3">
                                            @if (part.includes(':')) {
                                                <span class="col-form-label">{{ part.split(':')[0] }}:</span>
                                                {{ part.split(':')[1].trim() ? part.split(':')[1] : 'xxxxx' }}
                                            }
                                            @if (!part.includes(':')) {
                                                {{ part.trim() ? part : 'XXXXXX' }}
                                            }
                                        </div>
                                    }
                                </span>
                            }
                        }
                        <div class="mb-1">
                            <label class="col-form-label" translate="MATERIAL_AVAILABILITY_LABEL_TS"></label>
                            {{ material.tsPercentage }}%/{{ material.tsPercentageCounter }}
                        </div>
                        <div class="mb-1">
                            <label class="col-form-label" translate="MATERIAL_AVAILABILITY_LABEL_NDF"></label>
                            {{ material.ndfQuote }}%/{{ material.ndfCounter }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
}
